<template>
    <div>
        <a-button @click="showModal" class="btn-outline-primary">
            دریافت خروجی اکسل تراکنش ها
        </a-button>

        <a-modal width="1000px" v-model="visible" title="    دریافت خروجی اکسل    " on-ok="handleOk">
            <div class="row">
                <div class="col-md-6 ">
                    <div class="form-group">
                        <label style="margin-bottom:10px;">تاریخ پایان </label>
                        <date-picker v-model="info.end"></date-picker>

                    </div>
                </div>
                <div class="col-md-6 ">
                    <div class="form-group">
                        <label style="margin-bottom:10px;">تاریخ شروع </label>
                        <date-picker v-model="info.start"></date-picker>

                    </div>
                </div>

            </div>
            <template slot="footer">
                <a-button :disabled="loading" @click="validate()">
                    <a-icon type="upload" /> خروجی اکسل
                </a-button>
                <a-button key="back" @click="handleCancel">
                    بستن
                </a-button>
            </template>



        </a-modal>
    </div>
</template>
<script>
    export default {
        props: {
            answers: Object,
        },
        data() {
            return {
                loading: false,
                visible: false,
                info: {}
            };
        },
        methods: {
            async validate() {
                if (this.info.start == undefined && this.info.end == undefined) {
                    this.$toast.error("لطفا شروع و پایان بازه زمانی را وارد کنید.");
                } else {
                    let url =
                        `${this.$store.state.baseUrl}/transactions/report?start=${this.info.start}&end=${this.info.end}`
                    let _this = this;
                    this.loading=true;
                    await axios
                        .get(url)
                        .then(function(response) {
                            if (response.data.data === true) {
                                _this.loading=false;
                                _this.$toast.success('گزارش باموفقیت ثبت شد و در حال پردازش می باشد.');
                            }
                            _this.visible = false;
                            _this.$emit('getData')

                        })
                        .catch(function(err) {
                            _this.loading=false;
                            _this.$root.handleAxiosError(err);
                        });
                }
            },
            showModal() {
                this.visible = true;
            },
            handleOk(e) {
                this.loading = true;
                setTimeout(() => {
                    this.visible = false;
                    this.loading = false;
                }, 3000);
            },
            handleCancel(e) {
                this.visible = false;
                this.$emit('getData')

            },

        },
    };
</script>
